import { render } from "./EnMenubarComp.vue?vue&type=template&id=54660f13&scoped=true"
import script from "./EnMenubarComp.vue?vue&type=script&lang=js"
export * from "./EnMenubarComp.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "./EnMenubarComp.vue?vue&type=style&index=1&id=54660f13&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54660f13"]])

export default __exports__